module.exports = require("emojilib");